import React from 'react';
import { Descriptions } from 'antd';
import { formatPhone } from '../../utils/callLog';
import { Card, CardHead, TonePill } from '../../components';

export default function CompanyCard({ organization: org, offerings = [] }) {
  const website = org?.verticalData?.website;
  return (
    <Card aria-labelledby="company-title">
      <CardHead>
        <h2 id="company-title">Company</h2>
        <span>profile on file</span>
      </CardHead>
      <Descriptions column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }} size="small">
        <Descriptions.Item label="Name">{org?.name}</Descriptions.Item>
        <Descriptions.Item label="Plan">{org?.plan}</Descriptions.Item>
        <Descriptions.Item label="Timezone">{org?.settings?.timezone}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <TonePill $tone="success">{org?.status}</TonePill>
        </Descriptions.Item>
        <Descriptions.Item label="Contact">{org?.contact?.name || '—'}</Descriptions.Item>
        <Descriptions.Item label="Contact email">{org?.contact?.email || '—'}</Descriptions.Item>
        <Descriptions.Item label="Contact phone">{formatPhone(org?.contact?.phone)}</Descriptions.Item>
        <Descriptions.Item label="Website">
          {website ? (
            <a href={website} target="_blank" rel="noreferrer">
              {website}
            </a>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Services" span={2}>
          <span style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {offerings.map((o) => (
              <TonePill key={o.key} $tone="info">
                {o.label}
              </TonePill>
            ))}
          </span>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
